<template>
  <p v-if="value">
    <span>{{ value.length }}</span>
    <span v-if="hasMax"> / {{ max }}</span>
  </p>
</template>

<script>
export default {
  props: {
    value: { required: false },
    max: { type: [String, Number], required: false },
  },

  computed: {
    hasMax() {
      return Boolean(this.max)
    },
  },
}
</script>
